/* globals $, svgedit, unescape, DOMParser, ActiveXObject, getStrokedBBox */
/* jslint vars: true, eqeq: true, bitwise: true, continue: true, forin: true */
/**
 * Package: svgedit.utilities
 *
 * Licensed under the MIT License
 *
 * Copyright(c) 2010 Alexis Deveria
 * Copyright(c) 2010 Jeff Schiller
 */

// Dependencies:
// 1) jQuery
// 2) browser.js
// 3) svgtransformlist.js
// 4) units.js

(function () {
  'use strict';

  if (!svgedit.utilities) {
    svgedit.utilities = {};
  }

  // Constants

  // String used to encode base64.
  const KEYSTR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  const NS = svgedit.NS;

  // Much faster than running getBBox() every time
  const visElems = 'a,circle,ellipse,foreignObject,g,image,line,path,polygon,polyline,rect,svg,text,tspan,use';
  const visElems_arr = visElems.split(',');
  // var hidElems = 'clipPath,defs,desc,feGaussianBlur,filter,linearGradient,marker,mask,metadata,pattern,radialGradient,stop,switch,symbol,title,textPath';

  let editorContext_ = null;
  let domdoc_ = null;
  let domeditor_ = null;
  let domcontainer_ = null;
  let svgroot_ = null;

  svgedit.utilities.init = function (editorContext) {
    editorContext_ = editorContext;
    domdoc_ = editorContext.getDOMDocument();
    domeditor_ = editorContext.getDOMEditor();
    domcontainer_ = editorContext.getDOMContainer();
    svgroot_ = editorContext.getSVGRoot();
  };

  // Function: svgedit.utilities.toXml
  // Converts characters in a string to XML-friendly entities.
  //
  // Example: '&' becomes '&amp;'
  //
  // Parameters:
  // str - The string to be converted
  //
  // Returns:
  // The converted string
  svgedit.utilities.toXml = function (str) {
  // &apos; is ok in XML, but not HTML
  // &gt; does not normally need escaping, though it can if within a CDATA expression (and preceded by "]]")
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
  };

  // Function: svgedit.utilities.fromXml
  // Converts XML entities in a string to single characters.
  // Example: '&amp;' becomes '&'
  //
  // Parameters:
  // str - The string to be converted
  //
  // Returns:
  // The converted string
  svgedit.utilities.fromXml = function (str) {
    return $('<p/>').html(str).text();
  };

  // This code was written by Tyler Akins and has been placed in the
  // public domain.  It would be nice if you left this header intact.
  // Base64 code from Tyler Akins -- http://rumkin.com

  // schiller: Removed string concatenation in favour of Array.join() optimization,
  //        also precalculate the size of the array needed.

  // Function: svgedit.utilities.encode64
  // Converts a string to base64
  svgedit.utilities.encode64 = function (input) {
  // base64 strings are 4/3 larger than the original string
    input = svgedit.utilities.encodeUTF8(input); // convert non-ASCII characters
    // input = svgedit.utilities.convertToXMLReferences(input);
    if (window.btoa) {
      return window.btoa(input); // Use native if available
    }
    const output = new Array(Math.floor((input.length + 2) / 3) * 4);
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0; let p = 0;

    do {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output[p++] = KEYSTR.charAt(enc1);
      output[p++] = KEYSTR.charAt(enc2);
      output[p++] = KEYSTR.charAt(enc3);
      output[p++] = KEYSTR.charAt(enc4);
    } while (i < input.length);

    return output.join('');
  };

  // Function: svgedit.utilities.decode64
  // Converts a string from base64
  svgedit.utilities.decode64 = function (input) {
    if (window.atob) {
      return window.atob(input);
    }
    let output = '';
    let chr1; let chr2; let chr3 = '';
    let enc1; let enc2; let enc3; let enc4 = '';
    let i = 0;

    // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

    do {
      enc1 = KEYSTR.indexOf(input.charAt(i++));
      enc2 = KEYSTR.indexOf(input.charAt(i++));
      enc3 = KEYSTR.indexOf(input.charAt(i++));
      enc4 = KEYSTR.indexOf(input.charAt(i++));

      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;

      output = output + String.fromCharCode(chr1);

      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }

      chr1 = chr2 = chr3 = '';
      enc1 = enc2 = enc3 = enc4 = '';
    } while (i < input.length);
    return unescape(output);
  };

  // based on http://phpjs.org/functions/utf8_encode
  // codedread:does not seem to work with webkit-based browsers on OSX // Brettz9: please test again as function upgraded
  svgedit.utilities.encodeUTF8 = function (argString) {
  // return unescape(encodeURIComponent(input)); //may or may not work
    if (argString === null || typeof argString === 'undefined') {
      return '';
    }

    // .replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    const string = String(argString);
    let utftext = '';
    let start; let end; let stringl = 0;

    start = end = 0;
    stringl = string.length;
    let n;
    for (n = 0; n < stringl; n++) {
      let c1 = string.charCodeAt(n);
      let enc = null;

      if (c1 < 128) {
        end++;
      } else if (c1 > 127 && c1 < 2048) {
        enc = String.fromCharCode(
          (c1 >> 6) | 192, (c1 & 63) | 128
        );
      } else if ((c1 & 0xF800) != 0xD800) {
        enc = String.fromCharCode(
          (c1 >> 12) | 224, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128
        );
      } else {
      // surrogate pairs
        if ((c1 & 0xFC00) != 0xD800) {
          throw new RangeError('Unmatched trail surrogate at ' + n);
        }
        const c2 = string.charCodeAt(++n);
        if ((c2 & 0xFC00) != 0xDC00) {
          throw new RangeError('Unmatched lead surrogate at ' + (n - 1));
        }
        c1 = ((c1 & 0x3FF) << 10) + (c2 & 0x3FF) + 0x10000;
        enc = String.fromCharCode(
          (c1 >> 18) | 240, ((c1 >> 12) & 63) | 128, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128
        );
      }
      if (enc !== null) {
        if (end > start) {
          utftext += string.slice(start, end);
        }
        utftext += enc;
        start = end = n + 1;
      }
    }

    if (end > start) {
      utftext += string.slice(start, stringl);
    }

    return utftext;
  };

  // Function: svgedit.utilities.convertToXMLReferences
  // Converts a string to use XML references
  svgedit.utilities.convertToXMLReferences = function (input) {
    let n;
    let output = '';
    for (n = 0; n < input.length; n++) {
      const c = input.charCodeAt(n);
      if (c < 128) {
        output += input[n];
      } else if (c > 127) {
        output += ('&#' + c + ';');
      }
    }
    return output;
  };

  // Function: svgedit.utilities.text2xml
  // Cross-browser compatible method of converting a string to an XML tree
  // found this function here: http://groups.google.com/group/jquery-dev/browse_thread/thread/c6d11387c580a77f
  svgedit.utilities.text2xml = function (sXML, skipImageSanitize) {
    let out, dXML;

    if (sXML.indexOf('<svg:svg') >= 0) {
      sXML = sXML.replace(/<(\/?)svg:/g, '<$1').replace('xmlns:svg', 'xmlns');
    }

    if (!skipImageSanitize) sXML = INKIVE.Helpers.imagesSanitize.preLoadImagesSanitize(sXML);

    try {
      dXML = (window.DOMParser) ? new DOMParser() : new ActiveXObject('Microsoft.XMLDOM');
      dXML.async = false;
    } catch (e) {
      throw new Error('XML Parser could not be instantiated');
    }

    try {
      if (dXML.loadXML) {
        out = dXML.loadXML(sXML) ? dXML : false;
      } else {
        out = dXML.parseFromString(sXML, 'text/xml');
      }
    } catch (e2) { throw new Error('Error parsing XML string'); }

    if (!skipImageSanitize) {
      out = INKIVE.Helpers.imagesSanitize.postLoadBackgroundSanitize(out);
      out = INKIVE.Helpers.imagesSanitize.postLoadImagesSanitize(out);
    }

    return out;
  };

  // Function: svgedit.utilities.bboxToObj
  // Converts a SVGRect into an object.
  //
  // Parameters:
  // bbox - a SVGRect
  //
  // Returns:
  // An object with properties names x, y, width, height.
  svgedit.utilities.bboxToObj = function (bbox) {
    return {
      x: bbox.x,
      y: bbox.y,
      width: bbox.width,
      height: bbox.height
    };
  };

  // Function: svgedit.utilities.walkTree
  // Walks the tree and executes the callback on each element in a top-down fashion
  //
  // Parameters:
  // elem - DOM element to traverse
  // cbFn - Callback function to run on each element
  svgedit.utilities.walkTree = function (elem, cbFn) {
    if (elem && elem.nodeType == 1) {
      cbFn(elem);
      let i = elem.childNodes.length;
      while (i--) {
        svgedit.utilities.walkTree(elem.childNodes.item(i), cbFn);
      }
    }
  };

  // Function: svgedit.utilities.walkTreePost
  // Walks the tree and executes the callback on each element in a depth-first fashion
  // TODO: FIXME: Shouldn't this be calling walkTreePost?
  //
  // Parameters:
  // elem - DOM element to traverse
  // cbFn - Callback function to run on each element
  svgedit.utilities.walkTreePost = function (elem, cbFn) {
    if (elem && elem.nodeType == 1) {
      let i = elem.childNodes.length;
      while (i--) {
        svgedit.utilities.walkTree(elem.childNodes.item(i), cbFn);
      }
      cbFn(elem);
    }
  };

  // Function: svgedit.utilities.getUrlFromAttr
  // Extracts the URL from the url(...) syntax of some attributes.
  // Three variants:
  //  * <circle fill="url(someFile.svg#foo)" />
  //  * <circle fill="url('someFile.svg#foo')" />
  //  * <circle fill='url("someFile.svg#foo")' />
  //
  // Parameters:
  // attrVal - The attribute value as a string
  //
  // Returns:
  // String with just the URL, like someFile.svg#foo
  svgedit.utilities.getUrlFromAttr = function (attrVal) {
    if (attrVal) {
    // url("#somegrad")
      if (attrVal.indexOf('url("') === 0) {
        return attrVal.substring(5, attrVal.indexOf('"', 6));
      }
      // url('#somegrad')
      if (attrVal.indexOf("url('") === 0) {
        return attrVal.substring(5, attrVal.indexOf("'", 6));
      }
      if (attrVal.indexOf('url(') === 0) {
        return attrVal.substring(4, attrVal.indexOf(')'));
      }
    }
    return null;
  };

  // Function: svgedit.utilities.getHref
  // Returns the given element's xlink:href value
  svgedit.utilities.getHref = function (elem) {
    return elem.getAttribute('xlink:href');
  };

  // Function: svgedit.utilities.setHref
  // Sets the given element's xlink:href value
  svgedit.utilities.setHref = function (elem, val) {
    elem.setAttributeNS(NS.XLINK, 'xlink:href', val);
  };

  // Function: findDefs
  //
  // Returns:
  // The document's <defs> element, create it first if necessary
  svgedit.utilities.findDefs = function () {
    const svgElement = editorContext_.getSVGContent();
    let defs = svgElement.getElementsByTagNameNS(NS.SVG, 'defs');
    if (defs.length > 0) {
      defs = defs[0];
    } else {
      defs = svgElement.ownerDocument.createElementNS(NS.SVG, 'defs');
      if (svgElement.firstChild) {
      // first child is a comment, so call nextSibling
        svgElement.insertBefore(defs, svgElement.firstChild.nextSibling);
      } else {
        svgElement.appendChild(defs);
      }
    }
    return defs;
  };

  // TODO(codedread): Consider moving the next to functions to bbox.js

  // Function: svgedit.utilities.getPathBBox
  // Get correct BBox for a path in Webkit
  // Converted from code found here:
  // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
  //
  // Parameters:
  // path - The path DOM element to get the BBox for
  //
  // Returns:
  // A BBox-like object
  svgedit.utilities.getPathBBox = function (path) {
    const seglist = path.pathSegList;
    const tot = seglist.numberOfItems;

    const bounds = [[], []];
    const start = seglist.getItem(0);
    let P0 = [start.x, start.y];

    let i;
    for (i = 0; i < tot; i++) {
      const seg = seglist.getItem(i);

      if (typeof seg.x === 'undefined') { continue; }

      // Add actual points to limits
      bounds[0].push(P0[0]);
      bounds[1].push(P0[1]);

      if (seg.x1) {
        var P1 = [seg.x1, seg.y1];
        var P2 = [seg.x2, seg.y2];
        var P3 = [seg.x, seg.y];

        var j;
        for (j = 0; j < 2; j++) {
          const calc = function (t) {
            return Math.pow(1 - t, 3) * P0[j] +
            3 * Math.pow(1 - t, 2) * t * P1[j] +
            3 * (1 - t) * Math.pow(t, 2) * P2[j] +
            Math.pow(t, 3) * P3[j];
          };

          const b = 6 * P0[j] - 12 * P1[j] + 6 * P2[j];
          const a = -3 * P0[j] + 9 * P1[j] - 9 * P2[j] + 3 * P3[j];
          const c = 3 * P1[j] - 3 * P0[j];

          if (a == 0) {
            if (b == 0) {
              continue;
            }
            const t = -c / b;
            if (t > 0 && t < 1) {
              bounds[j].push(calc(t));
            }
            continue;
          }
          const b2ac = Math.pow(b, 2) - 4 * c * a;
          if (b2ac < 0) { continue; }
          const t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
          if (t1 > 0 && t1 < 1) { bounds[j].push(calc(t1)); }
          const t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
          if (t2 > 0 && t2 < 1) { bounds[j].push(calc(t2)); }
        }
        P0 = P3;
      } else {
        bounds[0].push(seg.x);
        bounds[1].push(seg.y);
      }
    }

    const x = Math.min.apply(null, bounds[0]);
    const w = Math.max.apply(null, bounds[0]) - x;
    const y = Math.min.apply(null, bounds[1]);
    const h = Math.max.apply(null, bounds[1]) - y;
    return {
      x,
      y,
      width: w,
      height: h
    };
  };

  // Function: getStrokedBBox
  // Get the bounding box for one or more stroked and/or transformed elements
  //
  // Parameters:
  // elems - Array with DOM elements to check
  //
  // Returns:
  // A single bounding box object
  svgedit.utilities.getStrokedBBox = function (elems) {
    if (!elems) return;
    elems = elems instanceof HTMLElement ? [elems] : elems;

    if (!elems.length) {
      return false;
    }

    let x1; let y1; let fullBB = null;

    _.each(elems, function (el) {
      if (el.parentNode) {
        const checkedBBox = getCheckedBBox(el);

        if (checkedBBox) {
          if (fullBB) {
            if (fullBB.x > checkedBBox.x) {
              fullBB.width += fullBB.x - checkedBBox.x;
              fullBB.x = checkedBBox.x;
            }

            if (fullBB.y > checkedBBox.y) {
              fullBB.height += fullBB.y - checkedBBox.y;
              fullBB.y = checkedBBox.y;
            }

            if (checkedBBox.x + checkedBBox.width > fullBB.x + fullBB.width) {
              fullBB.width = (checkedBBox.x + checkedBBox.width) - fullBB.x;
            }

            if (checkedBBox.y + checkedBBox.height > fullBB.y + fullBB.height) {
              fullBB.height = (checkedBBox.y + checkedBBox.height) - fullBB.y;
            }
          } else {
            fullBB = checkedBBox;
          }
        }
      }
    });

    return fullBB;

    // Make sure the expected BBox is returned if the element is a group
    function getCheckedBBox (elem) {
      try {
      // TODO: Fix issue with rotated groups. Currently they work
      // fine in FF, but not in other browsers (same problem mentioned
      // in Issue 339 comment #2).

        let bb = svgedit.utilities.getBBox(elem);
        const angle = svgedit.utilities.getRotationAngle(elem);

        if ((angle && angle % 90) ||
        svgedit.math.hasMatrixTransform(svgedit.transformlist.getTransformList(elem))) {
        // Accurate way to get BBox of rotated element in Firefox:
        // Put element in group and get its BBox
          let good_bb = false;

          // Get the BBox from the raw path for these elements
          const elemNames = ['ellipse', 'path', 'line', 'polyline', 'polygon'];
          if (elemNames.indexOf(elem.tagName) >= 0) {
            bb = good_bb = svgedit.path.getPathBBoxFromElement(elem);
          } else if (elem.tagName == 'rect') {
          // Look for radius
            const rx = elem.getAttribute('rx');
            const ry = elem.getAttribute('ry');
            if (rx || ry) {
              bb = good_bb = svgedit.path.getPathBBoxFromElement(elem);
            }
          }

          if (!good_bb) {
          // Must use clone else FF freaks out
            const clone = elem.cloneNode(true);
            const g = document.createElementNS(NS.SVG, 'g');
            const parent = elem.parentNode;
            parent.appendChild(g);
            g.appendChild(clone);
            bb = svgedit.utilities.bboxToObj(g.getBBox());
            parent.removeChild(g);
          }
        }

        return bb;
      } catch (e) {
        console.log(elem, e);
        return null;
      }
    }
  };

  // Function: groupBBFix
  // Get the given/selected element's bounding box object, checking for
  // horizontal/vertical lines (see issue 717)
  // Note that performance is currently terrible, so some way to improve would
  // be great.
  //
  // Parameters:
  // selected - Container or <use> DOM element
  function groupBBFix (selected) {
    if (svgedit.browser.supportsHVLineContainerBBox()) {
      try { return selected.getBBox(); } catch (e) {}
    }
    const ref = $.data(selected, 'ref');
    let matched = null;
    let ret, copy;

    if (ref) {
      copy = $(ref).children().clone().attr('visibility', 'hidden');
      $(svgroot_).append(copy);
      matched = copy.filter('line, path');
    } else {
      matched = $(selected).find('line, path');
    }

    let issue = false;
    try {
      if (matched.length) {
        matched.each(function () {
          const bb = this.getBBox();
          if (!bb.width || !bb.height) {
            issue = true;
          }
        });
        if (issue) {
          const elems = ref ? copy : $(selected).children();
          ret = svgedit.utilities.getStrokedBBox(elems);
        } else {
          ret = selected.getBBox();
        }
      } else {
        ret = selected.getBBox();
      }
    } catch (err) {
      ret = selected.getBoundingClientRect();
    }
    if (ref) {
      copy.remove();
    }
    return ret;
  }

  // Function: svgedit.utilities.getBBox
  // Get the given/selected element's bounding box object, convert it to be more
  // usable when necessary
  //
  // Parameters:
  // elem - Optional DOM element to get the BBox for
  svgedit.utilities.getBBox = function (elem) {
    const selected = elem;// || editorContext_.geSelectedElements()[0];
    if (!elem || elem.nodeType != 1) { return null; }
    let ret = null;
    const elname = selected.nodeName;

    function getClonedBBox (element) {
      let bbox;
      try {
        bbox = element.getBBox();
        bbox.width || recalculate();
      } catch (e) {
        recalculate();
      }

      function recalculate () {
        const $clone = $(element).clone();
        $clone.appendTo('#svgroot');
        bbox = $clone[0].getBBox();
        $clone.remove();
      }

      return bbox;
    }

    switch (elname) {
      case 'clipPath':
        var editor = INKIVE.Tool.getInstance().editor;
        var shape = selected.childNodes[0];

        if (!shape || !shape.getBBox) {
          return;
        }
        var bbox = getClonedBBox(shape);

        var rect = editor.canvas.addSvgElementFromJson({
          element: 'rect',
          attr: {
            x: bbox.x,
            y: bbox.y,
            width: bbox.width,
            height: bbox.height
          }
        });

        svgedit.recalculate.cloneTransfromList(shape, rect);
        selected.insertBefore(rect, shape);
        svgedit.recalculate.recalculateDimensions(rect);
        ret = getClonedBBox(rect);
        selected.removeChild(rect);

        break;

      case 'text':
        if (selected.textContent === '') {
          selected.textContent = 'a'; // Some character needed for the selector to use.
          ret = getClonedBBox(selected);
          selected.textContent = '';
        } else {
          try { ret = getClonedBBox(selected); } catch (e) {}
        }
        break;

      case 'path':
      // Not sure, but calculation of getPathBBox is not working right
      // if(!svgedit.browser.supportsPathBBox()) {
      //  ret = svgedit.utilities.getPathBBox(selected);
      // } else {
        try { ret = getClonedBBox(selected); } catch (e2) {}
        // }
        break;

      case 'g':
        if ($(selected).hasClass('textarea')) {
          try {
            ret = selected.getElementsByTagName('rect')[0].getBBox();
          } catch (e) {
            ret = getClonedBBox(selected);
          }

          break;
        }

      case 'a':
        ret = groupBBFix(selected);
        break;

      default:
        if (elname === 'use') {
          ret = groupBBFix(selected, true);
        }
        if (elname === 'use' || (elname === 'foreignObject' && svgedit.browser.isWebkit())) {
          if (!ret) { ret = getClonedBBox(selected); }
          // This is resolved in later versions of webkit, perhaps we should
          // have a featured detection for correct 'use' behavior?
          // ——————————
          // if(!svgedit.browser.isWebkit()) {
          const bb = {};
          bb.width = ret.width;
          bb.height = ret.height;
          bb.x = ret.x + parseFloat(selected.getAttribute('x') || 0);
          bb.y = ret.y + parseFloat(selected.getAttribute('y') || 0);
          ret = bb;
        // }
        } else if (~visElems_arr.indexOf(elname)) {
          try { ret = getClonedBBox(selected); } catch (e3) {
          // Check if element is child of a foreignObject
            const fo = $(selected).closest('foreignObject');
            if (fo.length) {
              try {
                ret = getClonedBBox(fo[0]);
              } catch (e4) {
                ret = null;
              }
            } else {
              ret = null;
            }
          }
        }

        if ($(elem).hasClass('layoutBox')) {
          const clipPath = svgedit.utilities.getClipPath(elem);
          let clipBBox = clipPath && svgedit.utilities.getBBox(clipPath.childNodes[0]);

          if (!clipBBox) {
            const ar_bb = elem.textContent.split(/[^-|\d\.]/);
            if (ar_bb.length === 4) {
              clipBBox = {
                x: Math.floor4(ar_bb[0]),
                y: Math.floor4(ar_bb[1]),
                width: Math.floor4(ar_bb[2]),
                height: Math.floor4(ar_bb[3])
              };
            }
          }

          ret = clipBBox || ret;
        }
    }

    return ret ? svgedit.utilities.bboxToObj(ret) : ret;
  };

  svgedit.utilities.getClipPath = function (elem) {
    if (!elem.getAttribute('clip-path')) {
      return null;
    }

    const clipPath = elem.getAttribute('clip-path')
      .replace('url(', '')
      .replace(')', '')
      .replace(/"/g, '');

    return $(clipPath).get(0);
  };
  // Function: svgedit.utilities.getRotationAngle
  // Get the rotation angle of the given/selected DOM element
  //
  // Parameters:
  // elem - Optional DOM element to get the angle for
  // to_rad - Boolean that when true returns the value in radians rather than degrees
  //
  // Returns:
  // Float with the angle in degrees or radians
  svgedit.utilities.getRotationAngle = function (elem, to_rad) {
    const selected = elem || editorContext_.getSelectedElements()[0];
    // find the rotation transform (if any) and set it
    const tlist = svgedit.transformlist.getTransformList(selected);
    if (!tlist) { return 0; } // <svg> elements have no tlist
    const N = tlist.numberOfItems;
    let i;
    for (i = 0; i < N; ++i) {
      const xform = tlist.getItem(i);
      if (xform.type == 4) {
        return to_rad ? xform.angle * Math.PI / 180.0 : xform.angle;
      }
    }
    return 0.0;
  };

  svgedit.utilities.getScale = function (elem) {
    const selected = elem || editorContext_.getSelectedElements()[0];
    const tlist = svgedit.transformlist.getTransformList(selected);

    if (!tlist) { return 0; } // <svg> elements have no tlist

    const N = tlist.numberOfItems;
    let i;
    const transformProperties = {};

    for (i = 0; i < N; ++i) {
      const xform = tlist.getItem(i);

      if (xform.type === SVGTransform.SVG_TRANSFORM_SCALE) {
        transformProperties.scale = xform;
      } else if (xform.type === SVGTransform.SVG_TRANSFORM_TRANSLATE) {
        transformProperties.translate = xform;
      }
    }

    return transformProperties;
  };
  // Function getRefElem
  // Get the reference element associated with the given attribute value
  //
  // Parameters:
  // attrVal - The attribute value as a string
  svgedit.utilities.getRefElem = function (attrVal) {
    return svgedit.utilities.getElem(svgedit.utilities.getUrlFromAttr(attrVal).substr(1));
  };

  // Function: getElem
  // Get a DOM element by ID within the SVG root element.
  //
  // Parameters:
  // id - String with the element's new ID
  if (svgedit.browser.supportsSelectors()) {
    svgedit.utilities.getElem = function (id) {
    // querySelector lookup
      return domeditor_.querySelector('#' + id);
    };
  }/* else if (svgedit.browser.supportsXpath()) {
  svgedit.utilities.getElem = function(id) {
    // xpath lookup
    return domdoc_.evaluate(
//      'svg:svg[@id="svgroot"]//svg:*[@id="'+id+'"]',
      'svg:*[@id="'+id+'"]',
      domeditor_,
      function() { return svgedit.NS.SVG; },
      9,
      null).singleNodeValue;
  };
  } */else {
    svgedit.utilities.getElem = function (id) {
    // jQuery lookup: twice as slow as xpath in FF
      return $(domeditor_).find('[id=' + id + ']')[0];
    };
  }

  // Function: assignAttributes
  // Assigns multiple attributes to an element.
  //
  // Parameters:
  // node - DOM element to apply new attribute values to
  // attrs - Object with attribute keys/values
  // suspendLength - Optional integer of milliseconds to suspend redraw
  // unitCheck - Boolean to indicate the need to use svgedit.units.setUnitAttr
  svgedit.utilities.assignAttributes = function (node, attrs, suspendLength, unitCheck) {
    if (!suspendLength) { suspendLength = 0; }
    // Opera has a problem with suspendRedraw() apparently
    const handle = null;
    if (!svgedit.browser.isOpera()) { svgroot_.suspendRedraw(suspendLength); }

    let i;
    for (i in attrs) {
      const ns = (i.substr(0, 4) === 'xml:'
        ? NS.XML
        : i.substr(0, 6) === 'xlink:' ? NS.XLINK : null);

      if (ns) {
        node.setAttributeNS(ns, i, attrs[i]);
      } else if (!unitCheck) {
        node.setAttribute(i, attrs[i]);
      } else {
        svgedit.units.setUnitAttr(node, i, attrs[i]);
      }
    }
    if (!svgedit.browser.isOpera()) { svgroot_.unsuspendRedraw(handle); }
  };

  // Function: cleanupElement
  // Remove unneeded (default) attributes, makes resulting SVG smaller
  //
  // Parameters:
  // element - DOM element to clean up
  svgedit.utilities.cleanupElement = function (element) {
    const handle = svgroot_.suspendRedraw(60);
    const defaults = {
      'fill-opacity': 1,
      'stop-opacity': 1,
      opacity: 1,
      stroke: 'none',
      'stroke-dasharray': 'none',
      'stroke-linejoin': 'miter',
      'stroke-linecap': 'butt',
      'stroke-opacity': 1,
      rx: 0,
      ry: 0
    };

    const replacements = {
      fill: {
        content: 'NONE',
        replacement: 'none'
      },
      stroke: {
        content: 'NONE',
        replacement: 'none'
      }
    };

    let attr, val;

    for (attr in replacements) {
      val = replacements[attr];
      if (val && element.getAttribute(attr) === val.content) {
        element.setAttribute(attr, val.replacement);
      }
    }

    for (attr in defaults) {
      val = defaults[attr];
      if (element.getAttribute(attr) === val) {
        element.removeAttribute(attr);
      }
    }

    svgroot_.unsuspendRedraw(handle);
  };

  // Function: snapToGrid
  // round value to for snapping
  // NOTE: This function did not move to svgutils.js since it depends on curConfig.
  svgedit.utilities.snapToGrid = function (value) {
  // var stepSize = editorContext_.getStepSize() * editorContext_.getZoomMultiplier();
  // var unit = editorContext_.getBaseUnit();
  // if (unit !== "px") {
  //   stepSize *= svgedit.units.getTypeMap()[unit];
  // }
    //
  // value = Math.round(value/stepSize) * stepSize;
    return value;
  };

  svgedit.utilities.preg_quote = function (str, delimiter) {
  // From: http://phpjs.org/functions
    return String(str).replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + (delimiter || '') + '-]', 'g'), '\\$&');
  };

  svgedit.utilities.createSVGBlurFilter = function () {
    if ($('#svg-effects').length) {
      return;
    }

    const svg = document.createElementNS(window.NAMESPACE_URIS.SVG, 'svg');
    svg.setAttribute('id', 'svg-effects');

    const filter = document.createElementNS(window.NAMESPACE_URIS.SVG, 'filter');
    filter.setAttribute('id', 'blur-filter');

    const blur = document.createElementNS(window.NAMESPACE_URIS.SVG, 'feGaussianBlur');
    blur.setAttribute('stdDeviation', '4');

    filter.appendChild(blur);
    svg.appendChild(filter);
    document.body.appendChild(svg);
  };
}());
